import Vue from 'vue';

export default Vue.extend({
  data(): { task: Promise<any>|null, isLoading: boolean } {
    return {
      task: null,
      isLoading: false,
    };
  },
  watch: {
    task(task: Promise<any>) {
      this.isLoading = true;
      task.finally(() => {
        this.isLoading = false;
      });
    },
  },
});
